// extracted by mini-css-extract-plugin
export default {"root":"Wiy0tuD2D5PULEOY1cq5"};